export const GET_CAREER_DEGREE_REQUIREMENTS = 'GET_CAREER_DEGREE_REQUIREMENTS';
export const GET_CAREER_DEGREE_REQUIREMENT_BY_ID = 'GET_CAREER_DEGREE_REQUIREMENT_BY_ID';
export const UPDATE_CAREER_DEGREE_REQUIREMENT = 'UPDATE_CAREER_DEGREE_REQUIREMENT';
export const DELETE_CAREER_DEGREE_REQUIREMENT = 'DELETE_CAREER_DEGREE_REQUIREMENT';
export const CREATE_CAREER_DEGREE_REQUIREMENT = 'CREATE_CAREER_DEGREE_REQUIREMENT';
